import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-main" }
const _hoisted_2 = { class: "card-footer ion-text-center" }

import { IonCard, IonCardContent, IonCardHeader, IonCardSubtitle } from "@ionic/vue";
import { onMounted, ref } from "vue";
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, ArcElement, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import { useMotion } from "@vueuse/motion";


export default /*@__PURE__*/_defineComponent({
  __name: 'BarChartCard',
  props: {
  subTitle: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: false
  },
  data: {
    type: Object,
    required: true
  }
},
  setup(__props) {

ChartJS.register(ArcElement, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const props = __props

let chartData = ref({}) as any
let chartOptions = ref({})
let additionalInfo = ref("")
let primaryColor = ref("")
let textColor = ref("white")
const card = ref()

let style = window.getComputedStyle(document.body)

const { variant } = useMotion(card, {
  initial: {
    opacity: 0,
    y: 100
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 300,
      type: 'keyframes',
      ease: 'easeIn',
    },
  }
})

onMounted(() => {
  primaryColor.value = style.getPropertyValue("--ion-color-primary")
  textColor.value = style.getPropertyValue("--ion-text-color")

  chartData.value = {
    labels: props.data?.map(() => ""),
    datasets: [{
      label: "",
      data: props.data?.map((value: any) => value.TableItemMeta.includes("-") ? +value.TableItemMeta.split("-")[0] : +value.TableItemMeta),
      backgroundColor: ["transparent", ...props.data?.map(() => "#676767")],
      borderWidth: "1",
      borderRadius: "5",
      borderColor: [primaryColor.value, ...props.data?.map(() => "transparent")]
    }]
  }

  chartOptions.value = {
    responsive: true,
    events: [],
    plugins: {
      legend: {
        display: false
      }  // hide the legend data
    },
    scales: {
      y: {
        grid: {
          display: false,
        },
        ticks: {
          display: false,
        },
        border: {
          display: false
        }
      },
      x: {
        grid: {
          display: false,
        },
        border: {
          display: true,
          color: textColor.value
        }
      }
    },
  }

  additionalInfo.value = props.data?.[0]?.TableItemLabel
})

function getValueDescription() {
  const val = props.data[0].TableItemMeta
  let seconds = ""
  let time = ""

  if(val.includes("-")) {
    [seconds, time] = val.split("-")
  }

  if(time.includes(",")) {
    return time.split(",")[0]
  } else {
    const data = time.split(":") as any
    return data[0] == 0 ? data[1] == 0 ? data[2] + " sec." : data[1] + " min." : data[0] + "hours"
  }
}

return (_ctx: any,_cache: any) => {
  return (Object.keys(_unref(chartData)).length)
    ? (_openBlock(), _createBlock(_unref(IonCard), {
        key: 0,
        ref_key: "card",
        ref: card,
        class: "ion-margin"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCardHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCardSubtitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.subTitle), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCardContent), null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(getValueDescription()), 1),
              _createVNode(_unref(Bar), {
                options: _unref(chartOptions),
                data: _unref(chartData)
              }, null, 8, ["options", "data"]),
              _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(additionalInfo)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512))
    : _createCommentVNode("", true)
}
}

})